/**
 * Shared color helpers for the canvas. Extracted so toolbar gauges,
 * review-pane chips, per-row indicators, and the field-scoped inspector
 * speak the same color language.
 */

export function confidenceColor(confidence: number | null | undefined): string {
  const c = typeof confidence === 'number' ? confidence : 0;
  if (c >= 0.9) return '#10b981';
  if (c >= 0.7) return '#f59e0b';
  return '#ef4444';
}

export type ConfidenceBucket = 'high' | 'medium' | 'low';

/**
 * Bucket a confidence score for filter chips.
 *
 * Per plan §B: rows produced by deterministic operations (set_constant,
 * aggregate, etc.) often have `undefined` confidence — they're not
 * predictions. Treating those as `'low'` would hide them behind the
 * `Low confidence` filter; treating them as `'high'` keeps them
 * visible alongside truly high-confidence AI predictions, which is
 * the right default since deterministic ≠ uncertain.
 */
export function confidenceBucket(confidence: number | null | undefined): ConfidenceBucket {
  if (typeof confidence !== 'number') return 'high';
  if (confidence >= 0.9) return 'high';
  if (confidence >= 0.7) return 'medium';
  return 'low';
}

export function severityColor(severity: 'error' | 'warning' | 'info'): string {
  if (severity === 'error') return '#ef4444';
  if (severity === 'warning') return '#f59e0b';
  return '#3b82f6';
}
